import { createBrowserRouter } from 'react-router'
import Landing from './pages/Landing'
import Join from './pages/Join'
import Setup from './pages/Setup'
import Control from './pages/Control'
import Draft from './pages/Draft'
import Board from './pages/Board'
import Results from './pages/Results'
import Admin from './pages/Admin'
import Lottery from './pages/Lottery'

export const router = createBrowserRouter([
  { path: '/', element: <Landing /> },
  { path: '/admin', element: <Admin /> },
  { path: '/join/:code', element: <Join /> },
  { path: '/setup', element: <Setup /> },
  { path: '/control', element: <Control /> },
  { path: '/draft/:code', element: <Draft /> },
  { path: '/board/:code', element: <Board /> },
  { path: '/results/:code', element: <Results /> },
  // Public and tokenless, same access model as /board/:code. No Rails route is
  // needed: the SPA catch-all already answers anything outside /api, /cable,
  // /rails and /vite.
  { path: '/lottery/:code', element: <Lottery /> },
])
